import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Utente } from '../lib/tipi'

interface StatoAuth {
  token: string | null
  utente: Utente | null
  entra: (token: string, utente: Utente) => void
  esci: () => void
  aggiornaUtente: (utente: Utente) => void
}

/**
 * Store di autenticazione persistito in localStorage.
 * Il token viene letto da api.ts come Bearer su ogni richiesta.
 */
export const useAuthStore = create<StatoAuth>()(
  persist(
    (set) => ({
      token: null,
      utente: null,
      entra: (token, utente) => set({ token, utente }),
      esci: () => set({ token: null, utente: null }),
      aggiornaUtente: (utente) => set({ utente }),
    }),
    {
      name: 'ringcoach-auth',
    },
  ),
)
